(function($) {
	"use strict";
	
	function init() {
		$('.input-checkbox__dummy').on('keydown', onDummyKeydown);
	}

	function onDummyKeydown({currentTarget, which: key}) {
		if (key === 13) {
			let input = currentTarget.previousElementSibling;
			let type = input.type;
			if ((type === 'radio' && !input.checked) || type !== 'radio') {
				input.checked = !input.checked;
				$(input).trigger("change");
			}
		}
	}
	
	$(init);
	
})(jQuery);